import React from "react";
import { useIntl } from "react-intl";
import html2canvas from "html2canvas";
// mui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// components
// eslint-disable-next-line import/no-cycle
import AIDisplayArea from "./AIDisplayArea";
// eslint-disable-next-line import/no-cycle
import FullScreenIconTool from "../../../../../../../main/widget/FullScreenIconTool";
import ButtonPanel from "./buttonPanel/ButtonPanel";

const SNAPage = () => {
  const intl = useIntl();

  const handleExportImage = async () => {
    const targetEle = document.getElementById("sna_display_area_wrapper");
    const fileName = `hsna-societyNetwork-${new Date().getTime()}.png`;
    const resolution = 5;
    const opts = {
      useCORS: true,
      scale: resolution,
      scrollX: 0,
      scrollY: -window.scrollY,
    };
    const mineType = "image/png";
    const canvas = await html2canvas(targetEle, opts);
    const url = canvas
      .toDataURL(mineType, 1)
      .replace(mineType, "image/octet-stream");
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.download = fileName;
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };

  return (
    <Grid
      container
      sx={{
        backgroundColor: "#FFFFFF",
        padding: "16px 24px 24px 24px",
        flexDirection: "column",
      }}
      rowGap={1}
    >
      <Grid item>
        <Typography
          textAlign="left"
          variant="subtitle1"
          sx={{ fontWeight: 700 }}
        >
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ai.sna.title",
            defaultMessage: `3. 網絡圖即時預覽`,
          })}
        </Typography>
      </Grid>
      <Grid item sx={{ position: "relative" }}>
        <Grid item sx={{ position: "absolute", top: "8px", right: "8px" }}>
          {" "}
          <Box display="flex" justifyContent="flex-end">
            {" "}
            <FullScreenIconTool />
          </Box>
        </Grid>
        <Grid item>
          <AIDisplayArea />
        </Grid>
        <Grid item sx={{paddingTop:"8px"}}>
          <Typography sx={{ fontWeight: 400, fontSize: "12px" }}>
            {intl.formatMessage({
              id: "sna.sidetool.digitalAITool.ai.sna.hintTitle",
              defaultMessage: `此區僅提供網絡圖預覽，若要編輯網絡圖外觀請先點擊「儲存至我的網絡圖」後到「個人資料集」產生網絡圖並進行編輯。`,
            })}
          </Typography>
        </Grid>
      </Grid>

      <Grid item container>
        <ButtonPanel handleExportImage={handleExportImage} />
      </Grid>
    </Grid>
  );
};

export default SNAPage;
